import React from "react";

/** Keep in sync with api/utils/withdrawFailReasons.js */
export const WITHDRAW_FAIL_REASON_OPTIONS = [
  { code: "upi_invalid", label: "UPI ID not valid / does not exist" },
  { code: "upi_inactive", label: "UPI ID inactive or blocked" },
  { code: "upi_name_mismatch", label: "UPI name mismatch with profile" },
  { code: "upi_limit_exceeded", label: "UPI limit exceeded" },
  { code: "bank_account_invalid", label: "Bank account number not valid" },
  { code: "ifsc_invalid", label: "IFSC not valid" },
  { code: "bank_account_closed", label: "Bank account closed / frozen" },
  { code: "bank_name_mismatch", label: "Bank account name mismatch" },
  { code: "bank_imps_failed", label: "Bank/IMPS transfer failed" },
  { code: "wrong_payout_details", label: "Wrong UPI or bank details" },
  { code: "kyc_pending", label: "KYC not completed" },
  { code: "kyc_name_mismatch", label: "Name mismatch with KYC" },
  { code: "profile_incomplete", label: "Update profile payout details" },
  { code: "min_amount", label: "Below minimum withdrawal" },
  { code: "duplicate_request", label: "Duplicate withdrawal request" },
  { code: "suspicious_activity", label: "Security review / suspicious" },
  { code: "cooldown_active", label: "Withdrawal cooldown active" },
  { code: "insufficient_balance", label: "Insufficient balance" },
  { code: "gateway_error", label: "Payment gateway error" },
  { code: "technical_issue", label: "Technical issue" },
  { code: "admin_review", label: "Rejected after manual review" },
  { code: "other", label: "Other (type note below)" },
];

export default function WithdrawFailReasonFields({
  failReason,
  onFailReasonChange,
  failNote,
  onFailNoteChange,
}) {
  return (
    <div className="mt-3 border-top pt-3">
      <label className="form-label fw-semibold text-danger mb-2">
        Reason for reject / fail <span className="text-danger">*</span>
      </label>
      <select
        className="form-select form-select-sm"
        value={failReason}
        onChange={(e) => onFailReasonChange(e.target.value)}
        required
      >
        <option value="">— Select reason (shown to user) —</option>
        {WITHDRAW_FAIL_REASON_OPTIONS.map((r) => (
          <option key={r.code} value={r.code}>
            {r.label}
          </option>
        ))}
      </select>
      {failReason === "other" && (
        <textarea
          className="form-control form-control-sm mt-2"
          rows={2}
          placeholder="Enter reason (user will see this message)"
          value={failNote}
          onChange={(e) => onFailNoteChange(e.target.value)}
          maxLength={500}
        />
      )}
      <p className="small text-muted mb-0 mt-2">
        User will see this reason in withdrawal history on the app.
      </p>
    </div>
  );
}
